var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.725 1.27521L27.495 2.50521L26.07 1.06521C25.485 0.480215 24.54 0.480215 23.94 1.06521L22.5 2.50521L21.06 1.06521C20.475 0.480215 19.515 0.480215 18.93 1.06521L17.505 2.50521L16.065 1.06521C15.48 0.480215 14.535 0.480215 13.95 1.06521L12.51 2.50521L11.07 1.06521C10.485 0.480215 9.54 0.480215 8.94 1.06521L7.5 2.50521L6.06 1.06521C5.475 0.480215 4.515 0.480215 3.93 1.06521L2.505 2.50521L1.275 1.27521C0.81 0.810215 0 1.14021 0 1.81521V24.0002C0 25.6502 1.35 27.0002 3 27.0002H27C28.65 27.0002 30 25.6502 30 24.0002V1.81521C30 1.14021 29.19 0.810215 28.725 1.27521ZM13.5 24.0002H3V15.0002H13.5V24.0002ZM27 24.0002H16.5V21.0002H27V24.0002ZM27 18.0002H16.5V15.0002H27V18.0002ZM27 12.0002H3V7.50021H27V12.0002Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.cedeb11134910619ffcf54fecefcfedb.svg";
export { ForwardRef as ReactComponent };